export function addClipboard() {
  window.addEventListener("phx:clipcopy", (event) => {
    if (!("clipboard" in navigator)) {
      alert("Sorry, your browser does not support clipboard copy.");
      return;
    }

    const target = event.target;
    const copyElement = target.querySelector(".copy-element");
    const confirmElement = target.querySelector(".confirm-element");
    let text = event.detail.text;
    const richtext = event.detail.richtext;
    const type = event.detail.type;

    const blobText = new Blob([text], { type: "text/plain" });
    let clipboardItem = {
      ["text/plain"]: blobText,
    };
    if (type === "richtext") {
      const blob = new Blob([richtext], { type: "text/html" });
      clipboardItem[["text/html"]] = blob;
    }
    navigator.clipboard
      .write([new ClipboardItem(clipboardItem)])
      .then(() => {
        if (copyElement) copyElement.classList.add("hidden");
        if (confirmElement) confirmElement.classList.remove("hidden");

        setTimeout(() => {
          if (copyElement) copyElement.classList.remove("hidden");
          if (confirmElement) confirmElement.classList.add("hidden");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error copying text: ", error);
      });
  });
}
